/**
 *  Copyright (c) 2021-present The TVM Engineering Authors.
 *
 */

import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import MUIDataTable from "mui-datatables";
import { options } from "./data";

interface Props {
  columns: Array<Object>;
  actions: Array<Object>;
  data: Array<Object>;
  options: Object;
  title: string;
  MUITableToolbar: string;
}

const DataTableComponent = React.memo((props: Props) => {
  const { columns, data, title, actions, MUITableToolbar } = props;

  const getMuiTheme = () =>
    createTheme({
      components: {
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundColor: "#ffffff",
              boxShadow: 0,
              minHeight: "64px",
              // padding: '0px 24px',
              // color: 'red'
              padding: 0,
            },
            elevation1: {
              boxShadow: 0,
            },
            elevation4: {
              boxShadow: 0,
            },
            elevation3: {
              boxShadow: "none",
            },
          },
        },
        MUIDataTableBodyRow: {
          styleOverrides: {
            root: {
              // backgroundColor: '#ffffff !important'
              // '&:hover': {
              //   backgroundColor: '#FF0000'
              // }
              // backgroundColor: '#ffffff',
              //    "&:hover": {
              //   backgroundColor: '#ffffff'
              // }
              // hover: {
              //   backgroundColor: '#FF0000'
              // }
            },
          },
        },
        MUIDataTableSelectCell: {
          styleOverrides: {
            headerCell: {
              backgroundColor: "",
            },
          },
        },
        MuiTableRow: {
          styleOverrides: {
            root: {
              "&:selected": {
                backgroundColor: "rgb(103 58 183 / 20%)",
              },
              "&:selected, &:selected:hover": {
                backgroundColor: "rgb(103 58 183 / 35%)",
              },
              "&:hover": {
                backgroundColor: "none",
                cursor: "arrow",
              },
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            colorPrimary: {
              "&:disabled": {
                display: "none",
              },
            },
          },
        },
        MUIDataTableToolbar: {
          styleOverrides: {
            left: {
              flex: MUITableToolbar || "1 1 auto",
            },
          },
        },
        MUIDataTableToolbarSelect: {
          styleOverrides: {
            root: {
              backgroundColor: "#ffffff",
              boxShadow: "none",
              paddingTop: 0,
              paddingBottom: 0,
            },
          },
        },
        MUIDataTableHeadCell: {
          styleOverrides: {
            fixedHeader: {
              backgroundColor: "#ffffff",
            },
          },
        },
        MUIDataTable: {
          styleOverrides: {
            root: {
              backgroundColor: "#ffffff",
              boxShadow: "none",
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            body: {
              cursor: "default",
            },
            root: {
              padding: "10px",
            },
          },
        },
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              // backgroundColor: '#FF0000'
              // '&:hover': {
              //   backgroundColor: '#FF0000'
              // }
            },
          },
        },
        "@media (min-width: 600px)": {
          MuiToolbar: {
            styleOverrides: {
              gutters: {
                paddingLeft: "10px !important",
                paddingRight: "24px !important",
                // paddingBottom: "10px !important",
              },
            },
          },
        },
        MuiToolbar: {
          styleOverrides: {
            gutters: {
              paddingLeft: "10px !important",
              paddingRight: "24px !important",
              // paddingBottom: "10px !important",
            },
          },
        },
      },
    });

  return (
    <ThemeProvider theme={getMuiTheme()}>
      <MUIDataTable
        title={title || []}
        data={data}
        columns={columns}
        options={props.options ? props.options : options}
        actions={actions}
      />
    </ThemeProvider>
  );
});

export default DataTableComponent;
